import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { t } from 'ttag';
import { Button } from '~/ui/buttons';

const StyledButton = styled(Button)`
  padding: 11px 100px;
`;

export const InformationCardButton = ({
  text,
  disabled,
  handleClickButton
}: {
  handleClickButton: () => void;
  disabled: boolean;
  text?: string;
}) => {
  const escFunction = useCallback(
    event => {
      if (event.keyCode === 27 && !disabled && handleClickButton) {
        handleClickButton();
      }
    },
    [disabled]
  );

  useEffect(() => {
    document.addEventListener('keydown', escFunction);

    return () => {
      document.removeEventListener('keydown', escFunction);
    };
  }, [escFunction]);

  return (
    <StyledButton
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={handleClickButton}
      onKeyDown={(e: any) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClickButton();
        }
      }}
    >
      {t`Got it!`}
    </StyledButton>
  );
};
